import type { RegistryProduct } from '@/types/productRegistry';

export const registryProductsMock: RegistryProduct[] = [
  {
    id: 'credit-decisioning-gateway',
    name: 'productRegistry.productRegistryProducts.creditDecisioningGateway',
    category: 'underwriting',
    status: 'active',
    environment: 'production',
    icon: 'inventory',
    renderMode: 'iframe',
    iframeUrl: 'https://example.com/credit-decisioning',
    activeUsers: 1240,
    version: '2.4.1',
    lastModified: '2026-01-14T10:30:00.000Z',
    owner: 'Platform Team',
  },
  {
    id: 'risk-tracker-alert-metrics',
    name: 'productRegistry.productRegistryProducts.riskTrackerAlertMetrics',
    category: 'monitoring',
    status: 'maintenance',
    environment: 'production',
    icon: 'monitoring',
    renderMode: 'iframe',
    iframeUrl: 'https://example.com/risk-tracker',
    activeUsers: 890,
    version: '1.8.0',
    lastModified: '2026-01-12T14:15:00.000Z',
    owner: 'Risk Operations',
  },
  {
    id: 'aml-compliance-portal',
    name: 'productRegistry.productRegistryProducts.amlCompliancePortal',
    category: 'compliance',
    status: 'active',
    environment: 'stage',
    icon: 'compliance',
    renderMode: 'native',
    activeUsers: 450,
    version: '3.1.2',
    lastModified: '2026-01-08T09:00:00.000Z',
    owner: 'Compliance Team',
  },
  {
    id: 'global-standard-database',
    name: 'productRegistry.productRegistryProducts.globalStandardDatabase',
    category: 'database',
    status: 'active',
    environment: 'production',
    icon: 'database',
    renderMode: 'remote',
    remoteModule: 'globalDatabase/App',
    activeUsers: 3120,
    version: '4.0.0',
    lastModified: '2026-01-03T16:45:00.000Z',
    owner: 'Data Platform',
  },
  {
    id: 'identity-access-gateway',
    name: 'productRegistry.productRegistryProducts.identityAccessGateway',
    category: 'identity',
    status: 'inactive',
    environment: 'sandbox',
    icon: 'identity',
    renderMode: 'iframe',
    iframeUrl: 'https://example.com/identity',
    activeUsers: 0,
    version: '0.9.5',
    lastModified: '2025-12-18T11:20:00.000Z',
    owner: 'Security Team',
  },
  {
    id: 'documentation-hub',
    name: 'productRegistry.productRegistryProducts.documentationHub',
    category: 'compliance',
    status: 'active',
    environment: 'production',
    icon: 'description',
    renderMode: 'native',
    activeUsers: 680,
    version: '1.2.0',
    lastModified: '2026-01-10T08:00:00.000Z',
    owner: 'Developer Experience',
  },
  {
    id: 'audit-portal',
    name: 'productRegistry.productRegistryProducts.auditPortal',
    category: 'monitoring',
    status: 'active',
    environment: 'production',
    icon: 'audit',
    renderMode: 'iframe',
    iframeUrl: 'https://example.com/audit',
    activeUsers: 210,
    version: '2.0.3',
    lastModified: '2026-01-05T13:30:00.000Z',
    owner: 'SecOps',
  },
  {
    id: 'feature-flag-console',
    name: 'productRegistry.productRegistryProducts.featureFlagConsole',
    category: 'monitoring',
    status: 'provisioning',
    environment: 'development',
    icon: 'flag',
    renderMode: 'native',
    activeUsers: 12,
    version: '0.1.0',
    lastModified: '2026-01-15T09:00:00.000Z',
    owner: 'Platform Team',
  },
];

export const registryProductTotalMock = 142;
